export default __webpack_public_path__ + "static/media/LOGIN_MOBILE_53.c02dfb4b.png";